module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Medium.de132efe.ttf";